import {EventListener} from "./eventVerteiler";

export function initScreenblockerEvents() {
    const listener = new EventListener();
    listener.addEventListener("requestScreenBlockEvent", ({requester})=> Screenblocker.requestBlock(requester))
        .addEventListener("requestScreenBlockEndEvent", ({requester})=>Screenblocker.releaseBlock(requester))
        .addEventListener("blockComponentByIDEvent", ({id})=>$("#" + id).addClass("component-blocked"))
        .addEventListener("unblockComponentByIDEvent", ({id})=>$("#" + id).removeClass("component-blocked"))
}


export class Screenblocker extends EventListener{
    private static blockingComponents = [] as string[];
    private static fireAfterUnblock = [] as any[];

    public static requestBlock(requester) {
        if (Screenblocker.blockingComponents.indexOf(requester) === -1) {
            Screenblocker.blockingComponents.push(requester);
            document.querySelector(".screenblocker")?.classList.add("active");
        }
    }
    private static removeRequesterFromBlockingComponents(requester) {
        const index = Screenblocker.blockingComponents.indexOf(requester);
        if (index > -1) {
            Screenblocker.blockingComponents.splice(index, 1);
        }
    }

    public static releaseBlock(requester) {
        Screenblocker.removeRequesterFromBlockingComponents(requester);
        if (Screenblocker.blockingComponents.length === 0) {
            document.querySelector(".screenblocker")?.classList.remove("active");
            Screenblocker.fireAfterUnblockCallbacks();
        }
    }

    private static fireAfterUnblockCallbacks() {
        if(Screenblocker.fireAfterUnblock.length === 0) {
            return;
        }
        const callback = Screenblocker.fireAfterUnblock.shift();
        callback();
        if(Screenblocker.isUnBlocked()) {
            Screenblocker.fireAfterUnblockCallbacks();
        }
    }

    public static isUnBlocked = ()=>Screenblocker.blockingComponents.length === 0;

    public static registerCallbackAfterUnblock(callback) {
        if(Screenblocker.blockingComponents.length === 0) {
            callback();
            return;
        }
        Screenblocker.fireAfterUnblock.push(callback);
    }
}
